// extracted by mini-css-extract-plugin
module.exports = {"title":"__title__k06x2","footerDesc":"__footerDesc__q0bB8","testimonial":"__testimonial__3IPqu"};